import { useSelector } from "react-redux";
import { generateThumbnail } from "../../Helpers/ThumbHelper";

const PrintLink = () => {

    const activeFloorPlanData = useSelector((state) => state.visualizer.activeFloorPlanData);
    const floorPlanSteps = useSelector((state) => state.visualizer.activeFloorPlanSteps);
    const activePackage = useSelector((state) => state.visualizer.activePackage);
    const trimProducts = useSelector((state) => state.visualizer.seriesData)[8489];
    const appliedProducts = [];

    const handleClick = function () {
        // Setup print page images
        const renderData = {
            "name" : activeFloorPlanData.name,
            "beds":activeFloorPlanData.beds,
            "baths":activeFloorPlanData.baths,
            "cars":activeFloorPlanData.cars,
            "exterior": { area: 'exterior', specifier: activeFloorPlanData["exterior"], sel: activeFloorPlanData["exteriorSel"] },
            "kitchen": { name: 'Kitchen', area: 'kitchen', specifier: activeFloorPlanData["kitchen"], sel: activeFloorPlanData["kitchenSel"] },
            "bathroom": { name: 'Bathroom', area: 'bathroom', specifier: activeFloorPlanData["bathroom"], sel: activeFloorPlanData["bathroomSel"] },
        };

        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if(['Door Trim','Window Trim'].includes(this.name)){
                let product = trimProducts[this.sel];
                appliedProducts.push({
                    step: this.name,
                    area: 'Exterior Upgrades',
                    productOneId: 'trim',
                    productOne: product.sku,
                    colorOne: product.name,
                    thumbOne: `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${product.id})&type=prod&extra=(focus=300)&Size=100`,
                    productTwoId: '',
                    productTwo: '',
                    colorTwo: '',
                    thumbTwo: '',
                });
            }
        });

        //EXTERIOR PAINT PACKAGES
        if (activePackage && typeof activePackage === 'object') {
            //BODY
            appliedProducts.push({
                step: 'Body',
                area: `EXTERIOR PAINT PACKAGE`,
                productOneId: 1,
                productOne: activePackage.scheme,
                colorOne: activePackage.body,
                thumbOne: `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${activePackage.bodyChamID})&type=prod&extra=(focus=300)&Size=100`,
                productTwoId: '',
                productTwo: '',
                colorTwo: '',
                thumbTwo: '',
            });
            //TRIM
            appliedProducts.push({
                step: 'Trim',
                area: `EXTERIOR PAINT PACKAGE`,
                productOneId: 1,
                productOne: activePackage.scheme,
                colorOne: activePackage.trim,
                thumbOne: `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${activePackage.trimChamID})&type=prod&extra=(focus=300)&Size=100`,
                productTwoId: '',
                productTwo: '',
                colorTwo: '',
                thumbTwo: '',
            });
            //FRONT DOOR
            appliedProducts.push({
                step: 'Front Door',
                area: `EXTERIOR PAINT PACKAGE`,
                productOneId: 1,
                productOne: activePackage.scheme,
                colorOne: activePackage.frontDoor,
                thumbOne: `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=COLOR(!${activePackage.frontDoorChamID})&type=prod&extra=(focus=300)&Size=100`,
                productTwoId: '',
                productTwo: '',
                colorTwo: '',
                thumbTwo: '',
            });
        }

        // Setup print page products
        floorPlanSteps.forEach(step => {
            if (step.selection !== -1) {

                if (!step.selection || step.selection.id === -1 || typeof step.selection != 'object')
                    return;

                const thumbOne = generateThumbnail(step.selection, 250, 500);
                const thumbTwo = step.secondarySelection 
                    ? `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${step.secondarySelection.id}&type=prod&extra=(focus=500)&Size=250`
                    : '';
        
                if(step.step != 'Exterior Upgrades'){
                    appliedProducts.push({
                        step: step.step,
                        area: step.area,
                        productOneId: step.selection.id,
                        productOne: step.selection.name,
                        colorOne: step.selection.color,
                        thumbOne: thumbOne,
                        productTwoId: step.secondarySelection.id,
                        productTwo: step.secondarySelection ? step.secondarySelection.name : '',
                        colorTwo: step.secondarySelection ? step.secondarySelection.color : '',
                        thumbTwo: thumbTwo,
                    });

                }
            }
        });

        // Save print data to loacalstorage
        localStorage.setItem("PRINT_DATA", JSON.stringify({
            renderData: renderData,
            prodData: appliedProducts
        }))
        

        // Opens up print page in a new tab
        window.open('/print.html');
    }

    return (
        <button onClick={handleClick}>
            Print
        </button>
    );
};

export default PrintLink;